import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { EventService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class EventResolver implements Resolve<any> {

  
  private eventService = inject(EventService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.eventService.getAllEvents({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
